@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.expandable-section {
  width: 100%;
  border: 1px solid @shipment-details-modal--content--border-color;

  &:not(:first-child) {
    border-top: 0;
  }

  &:last-child {
    border-bottom: 0;
  }
}

.shipment-display-wrapper {
  padding: 0 10px;
}

.shipment-details-modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: @shipment-details-modal--background-color;

  &.loading {
    height: 500px;
  }
}

.content-header {
  display: flex;
  background-color: @shipment-details-modal-header--content--background-color;
  border-bottom: 1px solid @shipment-details-modal--content--border-color;
  width: 100%;
  flex-direction: column;
  position: relative;
  z-index: 2;
}

.shipment-details-header-buttons div {
  display: inline-block;
}

.content-body {
  display: flex;
  flex-direction: row;
  background: @shipment-details-modal--content--background-color;
  z-index: 1;
  min-height: 0;
  flex: 1;
}

.content-left-section,
.content-right-section {
  position: relative;
}

.content-left-section {
  width: 100%;
  z-index: 2;
  border-right: 1px solid @shipment-details-modal--content--border-color;
}

.content-right-section {
  width: 445px;
  min-width: 445px;
  background: @shipment-details-modal--background-color;
  z-index: 1;
}

.padded-content-right-section {
  padding: 15px;
}

.content-left-section-content,
.content-right-section-content {
  display: flex;
  height: 100%;
  overflow: auto;
}

.content-right-section-content {
  background-color: @shipment-details-modal--content--background-color;
  flex-direction: column;
  align-items: center;
}

.content-order-info {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
}

.content-order-info-top {
  display: flex;
  flex-direction: row;
}

.order-info-left-side,
.order-info-right-side {
  display: flex;
  margin: 10px 0 0 10px;
  flex-direction: column;
  flex: 1;
}

.ship-to-left-border {
  display: flex;
  flex-direction: column;
  border-left: 1px solid @shipment-details-modal--content--border-color;
  padding-left: 10px;
}

.content-whole-line,
.content-shipby-batch {
  display: flex;
  margin-bottom: 10px;
}

.content-shipby-batch {
  flex-direction: row;
}

.content-split-line {
  display: flex;
  flex: 1;
}

.label {
  color: @shipment-details-modal--label--text-color;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.order-info-items {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-row-gap: 1px;
  padding-bottom: 1px;
  margin: 15px 10px 10px;
  background-color: @shipment-details-modal--items-list--divider-color;

  .header {
    font-size: 14px;
    padding: 5px;
    color: @shipment-details-modal-items-list--header--text-color;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background-color: @shipment-details-modal-header--content--background-color;
  }
}

.item-section-title {
  font-size: 14px;
  color: @shipment-details-modal-items-list--header--text-color;
  background-color: @shipment-details-modal--content--background-color;
  padding: 5px 5px 5px 10px;
}

.no-items-message {
  text-align: center;
  font-size: 13px;
  font-style: italic;
  background-color: @shipment-details-modal--content--background-color;
  padding: 5px 0;
  border-top: 1px solid @shipment-details-modal--items-list--divider-color;
  margin: 15px 10px 10px;
}

.white {
  background-color: @shipment-details-modal--content--background-color;
}

.combo-order-section {
  background-color: @shipment-details-modal--content--background-color;
  padding: 10px 0 5px 10px;
  display: flex;
  align-items: flex-end;
  min-width: 0;
}

.combo-order-number {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customs-declarations {
  width: 100%;
}
